import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const data =
  Cookies.get("loginData") !== "undefined" && Cookies.get("loginData")
    ? JSON.parse(Cookies.get("loginData"))
    : null;
let orgId;
let userId;
let createdBy;
let officialEmail;

const apiUrl = process.env.REACT_APP_BACKEND_URL;

const setTokenValues = () => {
  orgId = data.user.Organization.uuid;
  userId = 17;
  createdBy = data.user.uuid;
  officialEmail = data.user.officialEmail;
};

// get login data for change Password functionality
const getTokenValues = () => {
  const dt=Cookies.get("loginData")
  ? JSON.parse(Cookies.get("loginData"))
  : null;
     userId = dt?.id;
};

export const loginUser = createAsyncThunk(
  "loginUser",
  async (obj, thunkAPI) => {
    try {
      const response = await fetch(`${apiUrl}/v2/api/org/admin/auth`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      });
      const data = await response.json();
      // console.log(response.status, "response", data);
      if (response?.status === 200) {
        Cookies.set("loginData", JSON.stringify(data?.Data));
        Cookies.set("token", data?.Token);
        // Cookies.set("userName", data?.Data.firstName);
        Cookies.set("userEmail", data?.Data.username);
        const roles = data?.Roles.map((role) => {
          return role.roleName;
        });
        Cookies.set("roles", JSON.stringify(roles));

        // Convert the array to a JSON string
        const jsonData = JSON.stringify(data?.Roles);

        // Set the JSON string as a cookie
        Cookies.set("myCookie", jsonData);

        // localStorage.setItem('token', data.Data.token?.access?.token);
        // localStorage.setItem('userName', data.Data.user.firstName);
        // localStorage.setItem('isLoggedIn', true);
        // localStorage.setItem('orgId', data.Data.user.Organization?.uuid);
        // localStorage.setItem('organizationId', data.Data.user.organizationId);
        console.log(data, "data");
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log("Error", e.response.data);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
const initialStateValues = {
  isAuthSliceFetching: false,
  isAuthSliceSuccess: false,
  isAuthSliceError: false,
  authSliceErrorMessage: "",
  authSliceSuccessMessage:"",
  isAuthSliceFetchingSmall:false,

};

const authSlice = createSlice({
  name: "authentication",
  initialState: initialStateValues,
  reducers: {
    // omit reducer cases
    logout: (state, action) => {
      // Cookies.remove();
      return initialStateValues;
    },
    clearAllSliceStates:(state,action)=>{
      state.authSliceSuccessMessage='';
      state.authSliceErrorMessage='';
      state.isAuthSliceError=false;
      state.isAuthSliceFetching=false;
      state.isAuthSliceFetchingSmall=false;
      state.isAuthSliceSuccess=false;
    }
    },
  extraReducers: (builder) => {
    builder.addCase(loginUser.fulfilled, (state, { payload }) => {
      state.isAuthSliceFetching = false;
      //   state.isLoggedIn = true;
      state.isAuthSliceSuccess = true;
      state.loggedInUserName = payload?.firstName +" "+ payload?.lastName 
      state.loggedInUserId = payload?.id
      state.isAuthSliceSuccess = true;
 
      //   state.token = payload.token.access.token;

      return state;
    });
    builder.addCase(loginUser.rejected, (state, { payload }) => {
      state.isAuthSliceFetching = false;
      state.isAuthSliceError = true;
      state.authSliceErrorMessage = payload?.Message || "Something Went Wrong";
    });
    builder.addCase(loginUser.pending, (state, { payload }) => {
      state.isAuthSliceFetching = true;
    });

   
  },
  
});

export const { logout ,clearAllSliceStates} = authSlice.actions;
export default authSlice;
